import { createRouter as _createRouter, createMemoryHistory, createWebHistory } from "vue-router"
import type { RouteRecordRaw } from "vue-router"

const routes: RouteRecordRaw[] = [
  {
    path: "/",
    name: "home",
    component: () => import("../pages/home.vue")
  },
  {
    path: "/document/:title",
    redirect: (to) => ({ name: "blog", params: { title: to.params.title } })
  },
  {
    path: "/articles/:title",
    redirect: (to) => ({ name: "blog", params: { title: to.params.title } })
  },
  {
    path: "/blog/:title",
    name: "blog",
    component: () => import("../pages/document.vue")
  },
  {
    path: "/search",
    name: "search",
    component: () => import("../pages/search.vue")
  },
  {
    path: "/about",
    name: "about",
    component: () => import("../pages/about.vue")
  },
  {
    path: "/vellum/:share_id",
    name: "vellum-share",
    component: () => import("../pages/vellum-share.vue")
  },
  {
    path: "/:pathMatch(.*)*",
    name: "not-found",
    component: () => import("../pages/not-found.vue")
  }
]

export function createRouter() {
  return _createRouter({
    history: import.meta.env.SSR ? createMemoryHistory() : createWebHistory(),
    routes
  })
}
